var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1461_1402)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.57373,
    y: 0.57373,
    width: 24.8524,
    height: 24.8524,
    rx: 12.4262,
    fill: "#007AFF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 9.10994,
    r: 2.64735,
    fill: "white",
    stroke: "white",
    strokeWidth: 2.48524
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2478 25.5684C23.2478 31.0271 18.6916 35.5093 12.9999 35.5093C7.30823 35.5093 2.75202 31.0271 2.75202 25.5684C2.75202 20.1096 7.30823 15.6274 12.9999 15.6274C18.6916 15.6274 23.2478 20.1096 23.2478 25.5684Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.48524
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.57373,
    y: 1.57373,
    width: 22.8524,
    height: 22.8524,
    rx: 11.4262,
    stroke: "#007AFF",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1461_1402"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.57373,
    y: 0.57373,
    width: 24.8524,
    height: 24.8524,
    rx: 12.4262,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.a1fe8e5ad866a8860ff8d05619c55df5.svg";
export { ForwardRef as ReactComponent };